<template>
  <v-card class="ma-2" flat outlined>
    <v-card-title v-html="'Informații Hotel'"/>

    <v-divider class="mx-4"/>

    <v-card flat>
      <v-card-title class="title font-weight-light" v-html="'Adresă'"/>
      <v-card-text>
        <GmapMap :center="position" map-type-id="terrain" :zoom="15" style="width: 100%; height: 350px">
          <GmapMarker
            v-model="position"
            :position="position"
            :clickable="false"
            :draggable="false"
          />
        </GmapMap>
      </v-card-text>
      <v-card-text class="pt-0">
        <div>
          <v-icon class="mr-2" small>mdi-map-marker</v-icon>
          {{ hotel.address }}
        </div>
        <div>
          <v-icon class="mr-2" small>mdi-phone</v-icon>
          {{ hotel.phone }}
        </div>
        <div>
          <v-icon class="mr-2" small>mdi-email</v-icon>
          {{ hotel.email }}
        </div>
      </v-card-text>
    </v-card>

    <v-divider class="mx-4"/>

    <v-card flat>
      <v-card-title class="title font-weight-light" v-html="'Galerie'"/>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" class="mb-2">
            <v-img :src="image" :aspect-ratio="16/9"/>
          </v-col>
          <v-col cols="12">
            <v-slide-group v-model="model" center-active mandatory show-arrows>
              <v-slide-item v-for="(media, index) in hotel.media" :key="index" v-slot:default="{ active, toggle }">
                <v-img
                  :src="media.url.small"
                  :style="{width: '80px', height: '45px'}"
                  :aspect-ratio="16/9"
                  class="mx-1"
                  @click="toggle();image = media.url.original"
                >
                  <v-row class="fill-height" align="center" justify="center">
                    <v-scale-transition>
                      <v-icon v-if="active" color="white" v-text="'mdi-camera'"/>
                    </v-scale-transition>
                  </v-row>
                </v-img>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-divider class="mx-4"/>

    <v-card flat>
      <v-card-title class="title font-weight-light" v-html="'Facilități'"/>
      <v-card-text v-if="translations">
        <v-chip v-for="(facility, index) in hotel.facilities" :key="index" small class="ma-1">
          {{ getFacility(facility) }}
        </v-chip>
      </v-card-text>
    </v-card>

    <v-divider class="mx-4"/>

    <v-card flat>
      <v-card-title class="title font-weight-light" v-html="'Detalii'"/>
      <v-card-text v-html="hotel.description.ro.replace(/(?:\r\n|\r|\n)/g, '<br/>')"/>
    </v-card>

    <v-divider class="mx-4"/>

    <v-card flat>
      <v-card-title class="title font-weight-light" v-html="'Termeni'"/>
      <v-card-text v-html="hotel.terms.ro.replace(/(?:\r\n|\r|\n)/g, '<br/>')"/>
    </v-card>

  </v-card>
</template>

<script>

  export default {
    props: {
      hotel: {
        type: Object,
        default: () => null
      }
    },

    async created() {
      this.image = this.hotel.media[0].url.original;
      this.position = {
        lat: Number(this.hotel.latitude),
        lng: Number(this.hotel.longitude)
      };

      this.translations = await this.$axios.getTranslations();
    },

    data: () => ({
      model: null,
      image: null,
      position: null,
      translations: null
    }),

    methods: {
      getFacility(facility) {
        return this.translations['ro']['hotel-facilities'][facility] || facility
      }
    }
  }

</script>